export enum DaysForReminder{
   Opt1 = 1,
   Opt2 =2,
   Opt3 =3,
   Opt4 =4,
   Opt5 =5,
   Opt6 =6,
   Opt7 =7,
   Opt8 =14,
   Opt9 =21,
   Opt10 =30
}